import type { ReactNode } from "react";

/** Rótulos pt-BR para os valores de status usados pelo Centro Cirúrgico Control. */
export const statusNames: Record<string, string> = {
  active: "Ativo",
  inactive: "Inativo",
  free: "Livre",
  occupied: "Ocupada",
  cleaning: "Em setup",
  blocked: "Bloqueado",
  preparation: "Em preparação",
  finalization: "Em finalização",
  recognized: "Reconhecido",
  unrecognized: "Não reconhecido",
  pending: "Pendente",
  processing: "Enviando",
  sent: "Enviada",
  failed: "Falhou",
  cancelled: "Cancelada",
  waiting: "Aguardando entrada",
  in_room: "Em sala",
  exited: "Saiu",
  incomplete: "Cadastro incompleto",
  complete: "Cadastro completo",
  expired: "Expirado",
  revoked: "Revogado",
  facial_active: "Facial ativa",
  facial_missing: "Sem facial",
  reception: "Recepção",
  room: "Sala"
};

export type BadgeProps = {
  /** Valor bruto do status (vira classe CSS e é traduzido por `statusNames`). */
  value: string;
  /** Sobrescreve o rótulo traduzido. */
  label?: string;
  icon?: ReactNode;
};

export function Badge({ value, label, icon }: BadgeProps) {
  const safeValue = value.replace(/[^a-z0-9_-]/gi, "");
  return (
    <span className={safeValue ? `badge ${safeValue}` : "badge"}>
      {icon && <span aria-hidden="true">{icon}</span>}
      {label ?? statusNames[value] ?? value}
    </span>
  );
}
